import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"
import "ion.sound.min.js";
export default class extends Controller {
  static targets = ["unreadMessagesCount", "incomingMessages"]

  connect() {
    // Initialize the sound library
    this.initializeSound();

    // Get the current location_id
    const locationElement = document.getElementById("conversation-location-id") || document.getElementById("header-location-id");
    const locationId = locationElement?.dataset.locationId;

    if (locationId) {
      this.subscription = consumer.subscriptions.create(
        { channel: "TextMessagesChannel", location_id: locationId }, 
        {
        received: (data) => {
          this.updateNotificationCount(data.count)
          this.replaceMessages(data.message_html)
        }
      })

      // Subscribe to the sidebar chat channel
      this.sidebarSubscription = consumer.subscriptions.create(
        { channel: "SidebarChatChannel", location_id: locationId }, 
        {
        received: (data) => {
          this.updateSidebarChat(data.sidebar_chat_html, data.parent_id, data.unknown_number, data.direction);
          // Play notification only if message is inbound
          if (data.direction === "inbound") {
            this.playNotificationSound();
          }
        }
      });
    }
  }

  // Initialize the sound library
  initializeSound() {
    ion.sound({
      sounds: [{ name: "message_notification" }],
      path: "/sounds/",
      preload: true,
      multiplay: true,
      volume: 1.0
    });
  }

  updateNotificationCount(count) {
    if (this.hasUnreadMessagesCountTarget) {
      this.unreadMessagesCountTarget.textContent = count;
      this.unreadMessagesCountTarget.style.display = count > 0 ? '' : 'none';
    }
  }

  replaceMessages(messageHtml) {
    if (this.hasIncomingMessagesTarget) {
      this.incomingMessagesTarget.innerHTML = ""
      this.incomingMessagesTarget.insertAdjacentHTML("beforeend", messageHtml)
    }
  }

  // Update the sidebar chat item with the new message
  updateSidebarChat(sidebarChatHtml, parentId, unknownNumber, direction) {
    const chatItem = unknownNumber 
      ? document.querySelector(`#chatItem_${unknownNumber}`) 
      : document.querySelector(`#chatItem_${parentId}`);
    
    const isActive = chatItem?.classList.contains("active");
    const chatList = document.querySelector(".chat-list");
    const smsSidebar = document.querySelector(`.sms_sidebar`);

    // If the chat item does not exist, skip the update
    if (direction == "outbound" && !chatItem) {
      console.log(`Chat item for parentId: ${parentId} or unknownNumber: ${unknownNumber} does not exist. Skipping update.`);
      return;
    }

    // Remove any existing chat item with the same parentId to avoid duplicates
    if (chatItem) {
      chatItem.remove();
    }

    // console.log(sidebarChatHtml);
    // Insert the updated chat item at the top of the list
    if (chatList) {
      chatList.insertAdjacentHTML("afterbegin", sidebarChatHtml);
    }

    // Reapply the active class if it was previously selected
    if (isActive) {
      const newChatItem = unknownNumber 
        ? document.querySelector(`#chatItem_${unknownNumber}`) 
        : document.querySelector(`#chatItem_${parentId}`);
      if (newChatItem) {
        newChatItem.classList.add("active");
      }
    }

    // Scroll to the top
    if (smsSidebar) {
      smsSidebar.scrollTop = 0;
    }  
  }

  // Play the notification sound
  playNotificationSound() {
    ion.sound.play("message_notification");
  }

  disconnect() {
    this.subscription.unsubscribe()
    this.sidebarSubscription.unsubscribe()
  }
}